import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { setupStore } from './components/core/store';
import { App } from './components/modules/app/components/App/App';

// import 'antd/dist/antd.css';
import './components/assets/styles/index.scss';
import { ConfigProvider } from 'antd';

const store = setupStore();

const container = document.getElementById('root')!;
const root = createRoot(container);
export const colorPrimary = '#00A899';

type ThemeData = {
  borderRadius: number;
  colorPrimary: string;
  errorColor: string;
  Button?: {
    colorPrimary: string;
    colorLinkActive: string;
    colorLinkHover: string;
    algorithm?: boolean;
  };
};

export const defaultData: ThemeData = {
  borderRadius: 6,
  errorColor: 'red',
  colorPrimary: '#00A899',
  Button: {
    colorPrimary: colorPrimary,
    colorLinkActive: '#04867a',
    colorLinkHover: '#04e0cb',
  },
};

const Loader = () => {
  return <div>Loading...</div>;
};

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: defaultData.colorPrimary,
            borderRadius: defaultData.borderRadius,
          },
          components: {
            Button: {
              colorPrimary: defaultData.Button?.colorPrimary,
              colorLink: defaultData.Button?.colorPrimary,
              colorLinkActive: defaultData.Button?.colorLinkActive,
              colorLinkHover: defaultData.Button?.colorLinkHover,
              algorithm: defaultData.Button?.algorithm,
              borderRadius: 2,
            },
            Input: {
              borderRadius: 2,
            },
            Select: {
              borderRadius: 2,
            },
          },
        }}
      >
        <Suspense fallback={<Loader />}>
          <App />
        </Suspense>
      </ConfigProvider>
    </BrowserRouter>
  </Provider>,
);
